import { route, string } from 'react-router-typesafe-routes/dom'
const base = 'et/company/:companyId/usersModule' as const
const companyOnly = { companyId: string().defined() }

export const USERS_ROUTES = {
  usersList: route(base, { params: companyOnly }),
  groupsList: route(`${base}/groups`, { params: companyOnly }),
  labelsPage: route(`${base}/labels`, { params: companyOnly }),
  rolesList: route(`${base}/roles`, { params: companyOnly }),
}
